<script>
export default {}
</script>